import { FaHeart } from "react-icons/fa";

const FootBar = () => {
    return ( 
        <div className="footbar min-w-full text-black bg-yellow-500 justify-center px-auto py-2 md:px-auto bottom-0 static">
            <div className="text-center w-fit mx-auto px-2">
                <h1 className="flex px-auto font-bold text-center">with love from GPPAF <FaHeart className="text-red-600 ml-2 my-auto"/></h1>
            </div>
        </div>
     );
}
 
export default FootBar;